// /*!
//  * React FormControl Library v3.6.0 for FormEngine
//  * 
//  * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
//  * Released under the MIT license
//  * 
//  * 
//  * Date: 2022-03-02T17:08Z
//  * Copyright (c) <2022> <Xio Infotech Private Limited>
//  * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
//  */
import React, { useState, useEffect } from 'react'
import { FormControl, MenuItem, FormHelperText, InputLabel } from '@material-ui/core';
// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import Selects from '@mui/material/Select';
import { FormContext } from '../Component/Forms/FormContext';
import elementValidate from '../Component/validation';
import { useContext } from 'react';
import { APIGET } from '../services/APIServices';

import { MasterContext } from '../services/MasterContext';

function CheckBoxList(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();


  const { field_type, field_id, field_label, field_temp_value, field_placeholder, field_disabled, field_value, field_option_src, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
  let { masterData } = React.useContext(MasterContext);
  const [fieldOptions, setFieldOptions] = React.useState(field_options);
  const [fieldDisable, setFieldDisable] = useState(field_disabled);
  const { handleChange } = useContext(FormContext);
  const [list, setList] = useState([]);
  var str = field_value;
  // var arr = str.split(",").map(Number);
  const [initialSelection, setInitialSelection] = useState(field_temp_value.value ? field_temp_value.value.split(/,\s*|\s*,/) : []);
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkedValue, setCheckedValue] = useState([]);
  // alert(field_value)
  useEffect(() => {
    setFieldDisable(field_disabled)
  }, [field_disabled])

  useEffect(() => {
    setInitialSelection(field_temp_value.value ? field_temp_value.value.split(/,\s*|\s*,/) : [])
  }, [field_temp_value.value])
  
  useEffect(() => {
    if (field_temp_value.type === "Update" || field_temp_value.type === "Create") {
      const fieldValueArray = field_value.split(',').map(item => item.trim());

      // Check each value in fieldValueArray if it exists in initialSelection
      const allExistInInitialSelection = fieldValueArray.every(value => initialSelection.includes(value));
      if (!allExistInInitialSelection) {

        // const updatedCheckedItems = [...initialSelection, field_value];
        setCheckedItems(field_value ? field_value.split(/,\s*|\s*,/) : []);
      } else {
        handleChange(field_id, {}, '');
      }
    }
    else {
      setCheckedItems(field_value ? field_value.split(/,\s*|\s*,/) : [])
    }
    console.log(initialSelection, '   ' + field_value)
  }, [field_value])

  // useEffect(() => {
  //   setCheckedItems(field_value ? field_value.split(/,\s*|\s*,/) : [])
  // }, [field_value])

  const handleCheckboxChange = (value) => {
    if (field_temp_value.type === "Update" || field_temp_value.type === "Create") { 
      if (!initialSelection.includes(field_value)) {
    if (checkedItems.includes(value)) {
      setCheckedItems(checkedItems.filter((item) => item !== value));
      let values = checkedItems.filter((item) => item !== value).join(",")
      // let preValues=initialSelection.filter((item) => item !== value).join(", ")
      handleChange(field_id, {}, values);
    } else {
      setCheckedItems([value]);
      handleChange(field_id, {}, value);
    }}
  }else{
      if (checkedItems.includes(value)) {
        setCheckedItems(checkedItems.filter((item) => item !== value));
        let values = checkedItems.filter((item) => item !== value).join(",")
        // let preValues=initialSelection.filter((item) => item !== value).join(", ")
        handleChange(field_id, {}, values);
      } else {
        setCheckedItems([value]);
        handleChange(field_id, {}, value);
      }
    }
  };

  async function getOptions(props) {
    try {
      if (props.field_option_src_context) {
        // if(false){
        if (props.field_option_check_local_storage === "true" && (masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])) {
          setFieldOptions(masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]);
        }
        else {
          let APIRES = await APIGET(props.field_option_src_context + `/` + props.field_option_src_critieria).then(
            (APIRES) => {

              let responseArray = new Array();
              let _i = 0;
              if (props.field_select_all_label) {
                let _obj = new Object();
                _obj.option_label = props.field_select_all_label;
                _obj.value = props.field_select_all_value;
                responseArray[_i] = _obj;
                _i++;
              }
              Object.keys(APIRES.data).forEach(key => {
                let _obj = new Object();
                _obj.option_label = APIRES.data[key][props.field_option_label];
                _obj.value = APIRES.data[key][props.field_option_value];
                responseArray[_i] = _obj;
                _i++;
              })
              //fieldOptions = responseArray; 
              setFieldOptions(responseArray);
              if (masterData[`${props.field_option_src_context}` && `${props.field_option_src_context}`]) {
                if (masterData[`${props.field_option_src_context}`][`${field_id}`]) {
                  masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                }
                else {
                  masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                  masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                }
              }
              else {
                masterData[`${props.field_option_src_context}`] = {}
                masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
              }
            }
          );
        }
      }
    } catch (err) {/** TODO Do Nothing */ }
  }
  useEffect(() => {
    getOptions(field_option_src);
  }, [field_option_src?.field_option_src_critieria])


  return (
    <div className={classes.inputroot}>
      <div style={{ display: "flex" }}>
        <InputLabel className={classes.label}>{field_label}</InputLabel>{field_mandatory === "yes" ? <span
          style={{
            fontSize: "18px",
            color: "#d71729",
            fontWeight: "400",
            lineHeight: "20px",
            transform: "translateY(-2px)"
          }}>*</span> : null}
      </div>
      <div className={classes.CheckBoxList} >

        {fieldOptions.map((option, i) => (
          <label
            key={i}
            style={{
              color: field_temp_value.type === "Delete" && initialSelection.includes(option.value) ? "red" : "inherit",
              background: (field_temp_value.type === "Update" || field_temp_value.type === "Create") && initialSelection.includes(option.value) ? "#d6d6d6" : "inherit"
            }}
          >
            {/* {!(initialSelection.includes(option.value) && (field_temp_value.type === "Update" || field_temp_value.type === "Create")) && ( */}
              <input
                type="checkbox"
                value={option.value}
                checked={checkedItems.includes(option.value)}
                disabled={fieldDisable ? fieldDisable : (initialSelection.includes(option.value) && (field_temp_value.type === "Update" || field_temp_value.type === "Create"))}
                onChange={() => handleCheckboxChange(option.value)}
              />
            {/* )} */}
            {option.option_label}
          </label>
        ))}

      </div>
      {/* <div>Selected Value: {list.length ? list.join(', ') : null}</div> */}
      {/* {//console.log(list)} */}
    </div>
  );
}

export default CheckBoxList;


// import React, { useState, useEffect, useContext } from 'react';
// import { FormControl, MenuItem, FormHelperText, InputLabel } from '@material-ui/core';
// import ThemeControls from "../Component/AllThemesControl";
// import { FormContext } from '../Component/Forms/FormContext';
// import { APIGET } from '../services/APIServices';
// import { MasterContext } from '../services/MasterContext';

// function CheckBoxList(props) {
//   const { useStyle } = ThemeControls;
//   const classes = useStyle();

//   const {
//     field_type,
//     field_id,
//     field_label,
//     field_temp_value,
//     field_placeholder,
//     field_disabled,
//     field_value,
//     field_option_src,
//     field_options,
//     field_helperText,
//     field_minlength,
//     field_maxlength,
//     field_maxvalue,
//     field_value_type,
//     field_minvalue,
//     field_error_msg_required,
//     field_error_msg_minlength,
//     field_error_msg_maxlength,
//     field_error_msg_minvalue,
//     field_error_msg_maxvalue,
//     field_error_msg_uq,
//     field_mandatory
//   } = props;

//   let { masterData } = React.useContext(MasterContext);
//   const [fieldOptions, setFieldOptions] = useState(field_options);
//   const [fieldDisable, setFieldDisable] = useState(field_disabled);
//   const { handleChange } = useContext(FormContext);
//   const [checkedItems, setCheckedItems] = useState([]);
//   const [initialSelection, setInitialSelection] = useState(field_value ? field_value.split(/,\s*|\s*,/) : []);

//   useEffect(() => {
//     setFieldDisable(field_disabled);
//   }, [field_disabled]);

//   useEffect(() => {
//     handleChange(field_id, {}, checkedItems.join(","));
//   }, [checkedItems]);

//   const handleCheckboxChange = (value) => {
//     if (checkedItems.includes(value)) {
//       setCheckedItems(checkedItems.filter((item) => item !== value));
//     } else {
//       setCheckedItems([...checkedItems, value]);
//     }
//   };

//   useEffect(() => {
//     if (field_value) {
//       setInitialSelection(field_value.split(/,\s*|\s*,/));
//     }
//   }, [field_value]);

//   console.log(initialSelection)

//   async function getOptions(props) {
//     try {
//       if (props.field_option_src_context) {
//         if (props.field_option_check_local_storage === "true" && (masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])) {
//           setFieldOptions(masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]);
//         } else {
//           let APIRES = await APIGET(props.field_option_src_context + `/` + props.field_option_src_critieria);
//           let responseArray = [];
//           let _i = 0;
//           if (props.field_select_all_label) {
//             responseArray[_i] = { option_label: props.field_select_all_label, value: props.field_select_all_value };
//             _i++;
//           }
//           Object.keys(APIRES.data).forEach(key => {
//             responseArray[_i] = { option_label: APIRES.data[key][props.field_option_label], value: APIRES.data[key][props.field_option_value] };
//             _i++;
//           });
//           setFieldOptions(responseArray);
//           if (!masterData[`${props.field_option_src_context}`]) {
//             masterData[`${props.field_option_src_context}`] = {};
//           }
//           if (!masterData[`${props.field_option_src_context}`][`${field_id}`]) {
//             masterData[`${props.field_option_src_context}`][`${field_id}`] = {};
//           }
//           masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
//         }
//       }
//     } catch (err) {
//       // TODO: Handle error
//     }
//   }

//   useEffect(() => {
//     getOptions(field_option_src);
//   }, [field_option_src?.field_option_src_critieria]);

//   return (
//     <div className={classes.inputroot}>
//       <div style={{ display: "flex" }}>
//         <InputLabel className={classes.label}>{field_label}</InputLabel>
//         {field_mandatory === "yes" ? <span style={{ fontSize: "18px", color: "#d71729", fontWeight: "400", lineHeight: "20px", transform: "translateY(-2px)" }}>*</span> : null}
//       </div>
//       <div className={classes.CheckBoxList}>
//         {fieldOptions.map((option, i) => (
//           <label
//             key={i}
//             style={{
//               color: field_temp_value === "Delete" && initialSelection.includes(option.value) ? "red" : "inherit",
//               background: (field_temp_value === "Update" || field_temp_value === "Create") && initialSelection.includes(option.value) ? "#d6d6d6" : "inherit"
//             }}
//           >
//             <input
//               type="checkbox"
//               value={option.value}
//               checked={checkedItems.includes(option.value)}
//               disabled={fieldDisable ? fieldDisable : (initialSelection.includes(option.value) && (field_temp_value === "Update" || field_temp_value === "Create"))}
//               onChange={() => handleCheckboxChange(option.value)}
//             />
//             {option.option_label}
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default CheckBoxList;
